import { QueryFunctionContext } from '@tanstack/react-query';

import { baseQuery } from '../baseQuery';
import type { PrepaidItem } from 'types';

type PrepaidProductsResponse = {
  data: PrepaidItem[];
  total: number;
  current_page: number;
  last_page: number;
  per_page: number;
};

export const getPrepaidProducts = async ({
  queryKey,
}: QueryFunctionContext<[string, string | number | undefined, number]>) => {
  const customerId = queryKey[1];
  const page = queryKey[2];

  const response: PrepaidProductsResponse = await baseQuery(`customers/${customerId}/prepaid-products?page=${page}`);

  return response;
};
